import { render } from "./communicationLogs.vue?vue&type=template&id=90485d3c&scoped=true"
import script from "./communicationLogs.vue?vue&type=script&lang=js"
export * from "./communicationLogs.vue?vue&type=script&lang=js"

import "./communicationLogs.vue?vue&type=style&index=0&id=90485d3c&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90485d3c"]])

export default __exports__